import React, { FC, useCallback } from 'react';

import { Pressable } from '@rbilabs/universal-components';

import { t } from 'state/intl/translations';
import { ICartEntryType } from 'state/loyalty/in-restaurant-redemption';

import { BadgeAndIncrementor } from './badge-and-incrementor';
import {
  OfferItemDescription,
  OfferItemName,
  OfferItemPicture,
  RewardItemDescription,
  RewardItemName,
  RewardItemPicture,
} from './map-components';
import {
  InRestaurantRedemptionEntryContainer,
  InRestaurantRedemptionEntryContent,
  PictureAndDetails,
  RewardDetails,
  StyledIconX,
  WrapperName,
} from './reward-redemption.styled';
import { IRewardRedemptionItemProps } from './types';

export const RewardRedemptionItem: FC<React.PropsWithChildren<IRewardRedemptionItemProps>> = ({
  cartEntry,
  handleUpdateEntry,
  handleRemoveEntry,
}) => {
  const handleRemove = useCallback(() => {
    handleRemoveEntry(cartEntry);
  }, [cartEntry, handleRemoveEntry]);

  const renderContent = () => {
    if (cartEntry.type === ICartEntryType.REWARD) {
      return (
        <PictureAndDetails>
          <RewardItemPicture entryCartDetails={cartEntry.details} objectFitContain />

          <RewardDetails>
            <WrapperName>
              <RewardItemName entryCartDetails={cartEntry.details} />
            </WrapperName>
            <RewardItemDescription entryCartDetails={cartEntry.details} />

            <BadgeAndIncrementor cartEntry={cartEntry} handleUpdateEntry={handleUpdateEntry} />
          </RewardDetails>
        </PictureAndDetails>
      );
    }

    return (
      <PictureAndDetails>
        <OfferItemPicture entryCartDetails={cartEntry.details} objectFitContain />

        <RewardDetails>
          <WrapperName>
            <OfferItemName entryCartDetails={cartEntry.details} />
          </WrapperName>
          <OfferItemDescription entryCartDetails={cartEntry.details} />

          <BadgeAndIncrementor cartEntry={cartEntry} handleUpdateEntry={handleUpdateEntry} />
        </RewardDetails>
      </PictureAndDetails>
    );
  };

  return (
    <InRestaurantRedemptionEntryContainer newUI={false}>
      <InRestaurantRedemptionEntryContent>
        {renderContent()}

        <Pressable
          onPress={handleRemove}
          padding={'$4'}
          accessibilityRole="button"
          accessibilityLabel={t('removeItem')}
          testID="remove-item"
        >
          <StyledIconX />
        </Pressable>
      </InRestaurantRedemptionEntryContent>
    </InRestaurantRedemptionEntryContainer>
  );
};
